import { render } from "./ForgotPasswordPage.vue?vue&type=template&id=03b70b36&ts=true"
import script from "./ForgotPasswordPage.vue?vue&type=script&lang=ts"
export * from "./ForgotPasswordPage.vue?vue&type=script&lang=ts"

import "./ForgotPasswordPage.vue?vue&type=style&index=0&id=03b70b36&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__